import { BM_LATEST_SCAN_MAX_POLL_MS, BM_LATEST_SCAN_POLL_INTERVAL_MS, BM_LATEST_SCAN_STALE_THRESHOLD_MS } from '../consts';
export const isLatestScanStale = function (scanDate, nowMs) {
  if (nowMs === void 0) {
    nowMs = Date.now();
  }
  if (!scanDate) {
    return true;
  }
  return nowMs - scanDate.getTime() > BM_LATEST_SCAN_STALE_THRESHOLD_MS;
};
export const isLatestScanReadyForBmHandoff = function (latestScan, nowMs) {
  if (nowMs === void 0) {
    nowMs = Date.now();
  }
  return latestScan != null && latestScan.jobs.length > 0 && !isLatestScanStale(latestScan.scanDate, nowMs);
};
export const pollForFreshLatestScan = async _ref => {
  let {
    fetchLatestScan,
    now = Date.now,
    sleep = ms => new Promise(resolve => setTimeout(resolve, ms)),
    maxPollMs = BM_LATEST_SCAN_MAX_POLL_MS,
    pollIntervalMs = BM_LATEST_SCAN_POLL_INTERVAL_MS
  } = _ref;
  const startedAt = now();
  while (now() - startedAt < maxPollMs) {
    const latestScan = await fetchLatestScan();
    if (isLatestScanReadyForBmHandoff(latestScan, now())) {
      return latestScan;
    }
    await sleep(pollIntervalMs);
  }
  return null;
};
//# sourceMappingURL=poll-for-fresh-latest-scan.js.map